module.exports = __webpack_public_path__ + "static/media/blog3_2.c36a3937.webp";